export const TimeAggConst = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly'
} as const;
export type TimeAgg = (typeof TimeAggConst)[keyof typeof TimeAggConst];

export interface YearBoundary {
  dateKey: string;
  year: string;
}

const extractYear = (dateKey: string, timeAgg: TimeAgg): string => {
  if (timeAgg === TimeAggConst.QUARTERLY) return dateKey.split('-')[0];
  return dateKey.slice(0, 4);
};

export const findYearBoundaries = (dateKeys: string[], timeAgg: TimeAgg): YearBoundary[] => {
  const boundaries: YearBoundary[] = [];
  let lastYear = '';
  for (const dateKey of dateKeys) {
    const year = extractYear(dateKey, timeAgg);
    if (year !== lastYear && lastYear !== '') {
      boundaries.push({ dateKey, year });
    }
    lastYear = year;
  }
  return boundaries;
};

export const findDatesNeedingYear = (dateKeys: string[], timeAgg: TimeAgg): Set<string> => {
  const set = new Set<string>();
  if (timeAgg !== TimeAggConst.WEEKLY) return set;
  let lastYear = '';
  for (let i = 0; i < dateKeys.length; i++) {
    const year = dateKeys[i].slice(0, 4);
    if (i === 0 || year !== lastYear) {
      set.add(dateKeys[i]);
    }
    lastYear = year;
  }
  return set;
};

export const formatDateTick = (
  dateKey: string,
  timeAgg: TimeAgg,
  datesNeedingYear: Set<string>
): string => {
  if (timeAgg === TimeAggConst.MONTHLY) {
    const [yearStr, monthStr] = dateKey.split('-');
    const d = new Date(Number(yearStr), Number(monthStr) - 1);
    const month = d.toLocaleDateString('en-US', { month: 'short' });
    return `${month} '${yearStr.slice(2)}`;
  }
  if (timeAgg === TimeAggConst.QUARTERLY) {
    const [yearStr, q] = dateKey.split('-');
    return `${q} '${yearStr.slice(2)}`;
  }
  const d = new Date(`${dateKey}T00:00:00`);
  const month = d.toLocaleDateString('en-US', { month: 'short' });
  const day = d.getDate();
  if (datesNeedingYear.has(dateKey)) return `${month} ${day}, ${d.getFullYear()}`;
  return `${month} ${day}`;
};
